<template>
  <div class="dashboard" v-if='project'>

    <div class="project-info-section">
      <div class="project-title" v-if='project'>
        <input type="text" class="custom-project-input" :style="{'width': (project.title.length * 13 + 10) + 'px'}" v-model='project.title' @blur="updateProjectTitle()">
      </div>
      <div class="project-edu-btn">
        <v-switch
          v-model="activeEducationTitles"
          inset
        ></v-switch>
      </div>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#fff"
            v-bind="attrs"
            v-on="on"
            class="custom-board-btn"
          >
            Board Settings
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title style="cursor: pointer;" @click='storeModule()'>Add Module</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title style="cursor: pointer;">Invite Users To Project</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title style="cursor: pointer;" class='custom-board-li-btn'>Make This A Template</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title style="cursor: pointer;">Share Template</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </div>

    <draggable group="modules" :list='project.modules' @change='onModuleMove($event, project.modules)' dragClass="dragging-ticket" ghostClass="ghost-ticket" chosenClass="chosen-ticket" handle=".handle">

    <div v-if='project.modules' v-for='(module, indexModule) in project.modules' class="module">

      <div class="drag-handle">
        <v-icon class='handle'>fas fa-grip-vertical</v-icon>
      </div>

      <div class="module-education-title" v-show='activeEducationTitles'>
        <v-icon class='icon-edu'>fas fa-graduation-cap</v-icon>
        <span class="education-interactive" @click="openEducation(module.id)">Course Educate: </span> <input type="text" v-model='module.educationTitle'>
      </div>

      <div class="module-border" v-show='activeEducationTitles'> </div>

      <div class="module-title">
        <div class="module-title-arrow-btns">
          <v-icon class='arrow-btn' v-show='module.active' @click="module.active = false">fas fa-chevron-down</v-icon>
          <v-icon class='arrow-btn' v-show='!module.active' @click="module.active = true">fas fa-chevron-right</v-icon>
        </div>
        <input type="text" v-model='module.title' placeholder="Add Module Title" @blur="updateModule(module)">

        <div class="custom-delete-module-btn">
           <div class="icons">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class='icon-dot'>fas fa-ellipsis-h</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="deleteModule(module.id)" style="cursor: pointer;">
                  <v-list-item-title>Delete Module</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

          </div>
        </div>
      </div>

      <div class="notes-section" v-show='module.active' style="margin-left: -60px;">

        <note :notes="module" :key="customState"></note>

        <div class="add-note">
          <span @click='addNoteLast(module)'>+ Add Note</span>

          <span style="margin-left: 15px;" @click='addSubCategoryLast(module)'>+ Add Sub Category</span>
        </div>

        <div style="clear: both;"></div>

      </div>

    </div>

    </draggable>

    <div class="add-module" @click='storeModule()'>
      + Add Module
    </div>

    <!-- right drawer component for dashboard ticket info -->
    <note-drawer v-if='$store.state.noteDrawer'></note-drawer>

    <!-- education drawer component for education info on module -->
    <education-drawer></education-drawer>

  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import axios from 'axios'
import draggable from 'vuedraggable'

import NoteDrawer from '@/components/note-drawer/Note-drawer'
import Note from '@/components/dashboard/Note'
import EducationDrawer from '@/components/education-drawer/Education-drawer'

axios.defaults.withCredentials = true

export default {
  name: 'Home',
  components: {
    NoteDrawer,
    Note,
    EducationDrawer,
    draggable
  },

  data () {
  	return {
      project: null,
      active: false,
      selectedNote: null,
      timeout: 250,
      activeEducationTitles: false,
      componentKey: 0,
      moduleOptions: ['Add Module', 'Invite Users To Project', 'Make This A Template', 'Share Template']
  	}
  },

  computed: {
    customState () {
      return this.$store.state.testx
    }
  },

  methods: {

    init () {
      this.loadProject()
    },
    // load project
    async loadProject () {
      const response = await api.projects.getOne(this.$route.params.id)
      if (response.status < 300) {
        this.project = response.data.project
        this.project.modules.sort((a, b) => (a.order > b.order) ? 1 : -1)
      } else {
        console.log('Error loading project', response)
      }
    },
    // save module
    async storeModule () {
      let Dmodule = {
        title: '',
        educationTitle: 'Where Do I Start?',
        active: true,
        project_id: this.$route.params.id
      }
      // store new module
      const response = await api.modules.store(Dmodule)
      if (response.status < 300) {
        this.$toasted.show('Module created!', { type: 'success' })
        this.loadProject()
      } else {
        this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
        console.log('response error', response)
      }
    },

    async updateModule(moduleData) {
      console.log('moduleData', moduleData)
      const response = await api.modules.update(moduleData, moduleData.id)
      if (response.status < 300) {
        this.$toasted.show('Module updated!', { type: 'success' })
      } else {
        this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
      }
    },

    updateActive (data) {
      this.active = data
    },

    openTicket (note) {
      this.selectedNote = note
      this.active = true
    },

    fetchRefs () {
      return this.$refs
    },

    async addNoteLast (module) {
    // addNoteLast - adds note at the end of a module list
      let note = {
        title: '',
        status: 'to-do',
        description: '',
        check: false,
        focus: false,
        list: false,
        active: 1,
        parent_id: null,
        module_id: module.id
      }

      // store new note
      const response = await api.notes.store(note)
      if (response.status < 300) {
        let newNote = response.data.note
        newNote.notes_with_recursive_children = []
        module.notes_with_recursive_children.push(newNote) // add element for front
        this.focusInput('bd' + response.data.note.id)
        this.$store.commit('incrementState') // force rerender
        this.$toasted.show('Note added!', { type: 'success' })
      } else {
        this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
        console.log('Response error', response)
      }
    },

    async addSubCategoryLast (module) {

      if (module.notes_with_recursive_children.length > 0) {
        let note = {
          title: '',
          status: 'to-do',
          description: '',
          check: false,
          focus: false,
          list: false,
          active: 1,
          parent_id: module.notes_with_recursive_children[module.notes_with_recursive_children.length - 1].id,
          module_id: module.id
        }

        // store new note
        const response = await api.notes.store(note)
        if (response.status < 300) {
          let newNote = response.data.note
          newNote.notes_with_recursive_children = []
          module.notes_with_recursive_children[module.notes_with_recursive_children.length - 1].notes_with_recursive_children.push(newNote) // add element for front
          this.focusInput('bd' + response.data.note.id)
          this.$store.commit('incrementState') // force rerender
          this.$toasted.show('Sub-Category added!', { type: 'success' })
        } else {
          this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
          console.log('Response error', response)
        }
      }
    },

    focusInput(elementId) {
      Vue.nextTick()
        .then(function () {
          document.getElementById(elementId).focus()
      })
    },

    async onModuleMove (event, modules) {
      // order modules on move
      const response = await api.modules.order(modules)
      if (response.status < 300) {
        console.log('Module created!', response.data)
      } else {
        console.log('response error', response)
      }
    },

    openEducation (moduleId) {
      //localStorage.moduleEducationId = moduleId
      this.$store.commit('setEducationModuleId', moduleId)
      this.$store.commit('openEducationDrawer')
    },

    async deleteModule (id) {
      // delete module
      const response = await api.modules.delete(id)
      if (response.status < 300) {
        this.$toasted.show('Module deleted!', { type: 'info' })
        console.log('Module deleted!', response.data)
        setTimeout(function() {
          location.reload()
        }, 200)
      } else {
        this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
        console.log('response error', response)
      }
    },

    async updateProjectTitle () {

      let data = {
        title: this.project.title
      }

      const response = await api.projects.update(this.$route.params.id, data)
      if (response.status < 300) {
        this.$toasted.show('Module title updated!', { type: 'success' })
      } else {
        this.$toasted.show('There was an error. Please try again later.', { type: 'error' })
        console.log('response error', response)
      }
    }

  },

  mounted () {
    this.init()
  }

}
</script>

<style lang="scss" scoped>

  .dragging-ticket {
    opacity: 0 !important;
    .note {

    }

    .handle {

    }
  }

  .ghost-ticket {
    width: 100% !important;
    height: 5px !important;
    background: #dadada !important;
    overflow: hidden !important;

    .handle {

    }
  }

  .chosen-ticket {
    .note {
      height: 0 !important;
      opacity: 0;
    }

    .notes-title-arrow-btns {
      display: none;
    }

    .handle {
      opacity: 0;
    }
  }

  .focused {
    background: #EFF1F6 !important;

    .title {
      background: #fff;
    }
  }

  .focused-subnote {
    background: #EFF1F6 !important;

    .title {
      background: #fff;
    }
  }

  .project-info-section {
    width: 80%;
    overflow: auto;

    .project-title {
      float: left;
      font-size: 26px;
      font-weight: 600;
      margin-bottom: 30px;

      .custom-project-input {
        outline: none;
      }
    }

    .project-edu-btn {
      float: left;
      margin-top: -12px;
      margin-left: 20px;
    }

    .board-section {
      text-align: right;
    }

    .add-module-btn {
      float: right;
      width: 130px;
      height: 45px;
      font-size: 14px;
      line-height: 45px;
      border-radius: 3px;
      text-align: center;
      color: #fff;
      background: #4C84FF;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        opacity: 0.7;
      }

      .options {
        position: absolute;
        width: 180px;
        margin-left: -50px;
        border-radius: 3px;
        background: #fff;
        color: #484848;
        z-index: 9999999;


        .options-li {
          height: 30px;
          padding-top: 5px;
          padding-bottom: 5px;
          padding-left: 20px;
          font-size: 14px;
          text-align: left;
          color: #484848;
          z-index: 9999999;
        }
      }
    }

    .custom-board-btn {
      float: right;
      height: 40px;
      font-family: "Roboto", sans-serif !important;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      background: #4C84FF;
    }

    .custom-board-li-btn {
      cursor: pointer !important;
      background: red !important;
    }
  }


  .dashboard {
    margin-top: 30px;

    .module {
      width: 80%;
      margin-bottom: 45px;

      .drag-handle {
        position: absolute;
        width: 20px;
        margin-top: -2px;
        margin-left: -45px;
        cursor: pointer;
        transition: all 0.5s;


        &:hover {
          opacity: 0.65;
        }

        .handle {
          font-size: 14px;
          color: #a0aabd;
        }
      }

      .module-border {
        margin-top: -12px;
        margin-bottom: 30px;
        border: 1px solid #E7EAEF;
        z-index: 9;
      }

      .module-education-title {
        display: inline-block;
        position: relative;
        width: auto;
        font-size: 17px;
        background: #F8F9FB;
        color: #4C84FF;

        input {

          color: #4C84FF;
          outline: none;
        }

        input:focus {
          outline: 1px solid #bebebf;
        }

        span {
          font-weight: 600;
        }

        .icon-edu {
          margin-top: -3px;
          margin-right: 8px;
          font-size: 22px;
          color: #4C84FF;
        }
      }

      .education-interactive {
        cursor: pointer;
        transition: 0.25s all;

        &:hover {
          opacity: 0.7;
        }
      }

      .module-title {
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: 600;

        &:hover {
          opacity: 0.75;

          .custom-delete-module-btn {
            display: block;
          }
        }

        .custom-delete-module-btn {
          float: right;
          margin-top: -25px;
          z-index: 9999;
          cursor: pointer;
          transition: all 0.5s;
          display: none;

          &:hover {
            opacity: 0.75;
          }

          i {
            color: #9fa9bc;
          }
        }

        .module-title-arrow-btns {
          float: left;
          width: 20px;
          margin-top: -2px;

          button:before {
            font-size: 14px;
            color: #E0E1E3;
          }
        }

        input {
          width: calc(100% - 20px);
          outline: none;
        }
        input::placeholder {
          color: #dedfe0;
        }
      }
    }

    .add-note {
      float: left;
      margin-top: 5px;
      padding-left: 50px;
      font-size: 14px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }

    .add-subcategory {
      float: left;
      margin-top: 5px;
      padding-left: 20px;
      font-size: 14px;
      font-weight: 300;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }

    .add-module {
      width: 80%;
      height: 65px;
      margin-top: 20px;
      padding-left: 15px;
      padding-right: 15px;
      font-weight: 500;
      line-height: 65px;
      border-radius: 5px;
      background: #eff2f5;
      color: #7c869a;
      cursor: pointer;
      transition: all 0.25s;

      &:hover {
        opacity: 0.7;
      }
    }

  }

  .v-btn__content {
    font-family: "Roboto", sans-serif !important;
    font-size: 14px !important;
  }
</style>
